import React from 'react';

import DepositPanel from 'components/generic/DepositPanel.component';

import CN from './UiPage.module.scss'; // Since this is experiment, we can share the same .module.scss file

const INVITATION_STATUSES = {
  declined: 'declined',
  invited: 'invited',
  reminded: 'reminded',
  missing: 'missing',
};

const DepositPanelUi = () => (
  <div data-bem="DepositPanelUi" className={CN.container}>
    <div className={CN.container}>
      <div className={CN.title}>
        <strong>Variant = noDeposit | paid | requested | refunded </strong>
      </div>
      <div className={CN.verticalFlex}>
        <DepositPanel variant="noDeposit" text="Variant : noDeposit" price="106" status={INVITATION_STATUSES.missing}>
          <div>dropdown content here</div>
        </DepositPanel>
        <DepositPanel variant="paid" text="Variant : paid" price="20" />
        <DepositPanel variant="requested" text="Variant : requested" price="20" />
        <DepositPanel variant="refunded" text="Variant : refunded" price="25" />
      </div>
    </div>
  </div>
);

export default DepositPanelUi;
